import { WorkoutsTable } from '../../components/Tables/WorkoutsTable';
import { SearchInput } from '../../components/UI/SearchInput';
import { PageContainer } from '../../components/Layout/PageContainer';
import { PageBreadcrumb } from '../../components/UI/PageBreadcrumb';
import { useWorkoutQuery } from '../../query/useWorkoutQuery';
import { Spinner } from '@chakra-ui/react';

export function WorkoutInfoPage() {
  const { data, isLoading } = useWorkoutQuery()

  return (
    <PageContainer>
      <PageBreadcrumb items={['Home', 'Workout Info']} />
      <SearchInput />
      {isLoading ? <Spinner size="xl" mt="40px" color="teal.500" /> :
        <WorkoutsTable data={data ?? []} onAdd={() => {}} />
      }
    </PageContainer>
  );
}